module.exports = __webpack_public_path__ + "img/us_banner.32433890.jpg";